import { Button, Container, Divider, List, ListItem, ListItemText } from '@mui/material';
import Drawer from '@shared/components/Drawer/Drawer';
import MigrationLink from '@shared/components/MigrationLink/MigrationLink';
import useMsalUser from '@shared/hooks/useMsalUser';
import useNavigateToSearch from '@shared/hooks/useNavigateToSearch';
import urlData from '@shared/utilities/routes';
import { NavLink } from 'react-router-dom';

import CarMaxLogo from '../../../CarMaxLogo';
import styles from './NavDrawer.module.scss';

interface NavDrawerProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function NavDrawer({ isOpen, onClose }: NavDrawerProps) {
    const { signOut, signIn, isAuthenticated } = useMsalUser();
    const goToSearch = useNavigateToSearch();

    return (
        <Drawer
            className="mobile-nav-drawer"
            isOpen={isOpen}
            onClose={onClose}
            header={<CarMaxLogo lightTheme logoType="small" />}>
            <Container disableGutters sx={{ marginTop: '24px' }}>
                <nav role="navigation" aria-label="main">
                    <List>
                        {isAuthenticated && (
                            <ListItem disableGutters className={styles['nav-link-btn']}>
                                <Button
                                    disableRipple={true}
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    color={'cta' as any}
                                    variant="contained"
                                    sx={{ height: '48px' }}
                                    fullWidth
                                    onClick={() => {
                                        goToSearch();
                                        onClose();
                                    }}>
                                    SEARCH INVENTORY
                                </Button>
                            </ListItem>
                        )}
                        {!isAuthenticated && (
                            <ListItem disableGutters className={styles['nav-link-btn']}>
                                <Button
                                    disableRipple={true}
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    color={'cta' as any}
                                    variant="contained"
                                    sx={{ height: '48px' }}
                                    fullWidth
                                    onClick={signIn}>
                                    SIGN IN
                                </Button>
                            </ListItem>
                        )}
                        <ListItem className={styles['nav-link']}>
                            <MigrationLink config={urlData.about}>ABOUT US</MigrationLink>
                        </ListItem>
                        <ListItem className={styles['nav-link']}>
                            <MigrationLink config={urlData.locations}>
                                LOCATIONS &amp; SCHEDULES
                            </MigrationLink>
                        </ListItem>
                        <ListItem className={styles['nav-link']}>
                            <MigrationLink config={urlData.faq}>FAQ</MigrationLink>
                        </ListItem>
                        {isAuthenticated && (
                            <>
                                <ListItem className={styles['nav-link']}>
                                    <MigrationLink config={urlData.checkin}>
                                        SIMULCAST
                                    </MigrationLink>
                                </ListItem>
                                <ListItem className={styles['nav-link']}>
                                    <NavLink
                                        to={urlData.checkout.mfeLink}
                                        aria-label={urlData.checkout.ariaLabel}
                                        onClick={onClose}>
                                        CHECKOUT
                                    </NavLink>
                                </ListItem>
                            </>
                        )}
                    </List>
                </nav>
                {isAuthenticated && (
                    <>
                        <Divider />
                        <nav role="navigation" aria-label="member">
                            <List>
                                <ListItem
                                    disablePadding
                                    disableGutters
                                    className={styles['nav-link-btn']}>
                                    <ListItemText
                                        disableTypography
                                        sx={{ color: '#000', fontWeight: '700', fontSize: '14px' }}>
                                        MEMBER DASHBOARD
                                    </ListItemText>
                                </ListItem>
                                <ListItem className={styles['nav-link-dashboard']}>
                                    <MigrationLink config={urlData.myAuctions} onClick={onClose}>
                                        My Auctions
                                    </MigrationLink>
                                </ListItem>
                                <ListItem className={styles['nav-link-dashboard']}>
                                    <MigrationLink config={urlData.savedSearches} onClick={onClose}>
                                        Saved Searches
                                    </MigrationLink>
                                </ListItem>
                                <ListItem className={styles['nav-link-dashboard']}>
                                    <MigrationLink
                                        config={urlData.myTransactions}
                                        onClick={onClose}>
                                        My Transactions
                                    </MigrationLink>
                                </ListItem>
                                <ListItem className={styles['nav-link-dashboard']}>
                                    <MigrationLink config={urlData.myList} onClick={onClose}>
                                        My List
                                    </MigrationLink>
                                </ListItem>
                                <ListItem className={styles['nav-link-dashboard']}>
                                    <MigrationLink config={urlData.myProfile} onClick={onClose}>
                                        My Profile
                                    </MigrationLink>
                                </ListItem>
                                <ListItem sx={{ fontSize: '14px' }} line-height="20px">
                                    <ListItemText
                                        onClick={() => signOut()}
                                        sx={{
                                            color: '#E01F1F',
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            my: '0px',
                                            height: 1.429,
                                        }}>
                                        Sign Out
                                    </ListItemText>
                                </ListItem>
                            </List>
                        </nav>
                    </>
                )}
            </Container>
        </Drawer>
    );
}
